import axios from "axios";

export const state = {
    storedetails: [],
};

export const getters = {
    storedetails: state => state.storedetails,
};

export const mutations = {
    setStoredetails(state, newValue) {
        state.storedetails = newValue
    },
};

export const actions = {
    fetchStoredetails({ commit }) {
        axios.get('/storedetails').then(res => {
            commit('setStoredetails', res.data.storedetails)
        })
    },
};
